let mobileMenuLoaded = false

class MobileMenu extends window.BAO.CustomElement() {
  connectedCallback () {
    if (mobileMenuLoaded) return

    window.BAO.sectionRenderer
      .fetch(
        'drawers-navigation',
        `${window.Shopify.routes.root}?view=mobile-menu`,
      )
      .then((res) => {
        mobileMenuLoaded = true

        const newDOM = window.BAO.sectionRenderer.convertToDOM(
          res['drawers-navigation'],
        )
        const myself = newDOM.querySelector(this.localName)

        this.outerHTML = myself.outerHTML

        const drawer = document.querySelector('site-drawer[key="menu"]')
        const drawerNavLinks = drawer.querySelectorAll('[data-gtm-nav-link]')

        drawerNavLinks.forEach((el) => {
          el.addEventListener('click', this.handleDrawerNavClick.bind(this))
        })
      })
      .catch(() => {})
  }

  handleDrawerNavClick (e) {
    e.stopImmediatePropagation()

    const target = e.currentTarget
    const targetLevel = target.closest('[data-gtm-target-level]')
    const targetContext = target.closest('[data-gtm-target-context]')
    const targetElement = target.closest('[data-gtm-target-element]')

    window.dataLayer.push({
      event: 'nav_link_click_drawer',
      target_text: target.dataset.gtmTargetText || target.innerText,
      target_level: targetLevel?.dataset.gtmTargetLevel,
      target_context: targetContext?.dataset.gtmTargetContext,
      target_element: targetElement?.dataset.gtmTargetElement || 'link',
    })
  }
}

if (!customElements.get('mobile-menu')) {
  customElements.define('mobile-menu', MobileMenu)
}
